import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { BaseDialog, ClockCircleOutlineIcon } from '@metarouter-private/mr-mui';

import { ENTITY_LABELS } from 'app/audit-logs/entity-labels';

import AuditLogPanel from './AuditLogPanel';
import auditLogPropTypes from 'app/audit-logs/auditLogPropTypes';

const TITLE_ID = 'auditLogModalTitle';
const DEFAULT_TITLE = 'Audit Log';

export default function AuditLogModal({ open, onClose, recordRef }) {
  const titleRef = useRef(null);

  const dialogProps = {
    open,
    onClose,
    fullWidth: true,
    maxWidth: 'xl',
    'aria-labelledby': TITLE_ID,
    'data-test-id': 'auditLogModal',
    PaperProps: { 'aria-modal': true },
    TransitionProps: { onEntered: () => titleRef.current?.focus() },
  };

  const title = (
    <span id={TITLE_ID} ref={titleRef} tabIndex={-1} data-test-id={TITLE_ID}>
      {buildModalTitle(recordRef)}
    </span>
  );

  return (
    <BaseDialog
      DialogProps={dialogProps}
      title={title}
      TitleIcon={ClockCircleOutlineIcon}
      content={<AuditLogPanel recordRef={recordRef} />}
    />
  );
}

AuditLogModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  recordRef: auditLogPropTypes.recordRef.isRequired,
};

function buildModalTitle({ entity, displayName }) {
  const label = ENTITY_LABELS[entity]?.singular;
  if (!label || !displayName) return DEFAULT_TITLE;

  return `${DEFAULT_TITLE} for ${label.toLowerCase()} '${displayName}'`;
}
